import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const allFeedbackList = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(
      data, apiConstants.USER.ADMIN_ALL_FEEDBACK,
   

    )
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
